import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, Message, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import CheckboxRowHaveSubForm from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubForm'
import scrollToComponent from 'react-scroll-to-component'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSubProjectSidebar } from '../../redux/actions/sidebar'
import CheckboxRowHaveSubView from '../../components/forms/checkboxRowForm/CheckboxRowHaveSubView'
import { SUB_PROJECT_ID } from '../../constants/constants'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import ButtonPanel from '../ButtonPanel'
import { setAlertMessage } from '../../utils/messageUtil'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import CustomAlertMessage from '../CustomAlertMessage'
import { saveSubProjectProjectGoal } from '../../redux/actions/subProjectProposal'
// import './styles.less'

export default function SubProjectGoalTenYear(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const dispatch = useDispatch()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [notiMsg, setNotiMsg] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleUpdateGoalTenYear = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      console.log('request : ', request)
      const response = await saveSubProjectProjectGoal(subProjectId, request)

      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
        await dispatch(getSchemaSubProjectSidebar(subProjectId))
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }

      onChangeIsEdit(false)
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const [formSchema, setFormSchema] = useState(schema)

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    let request = {
      optionSelected: data.selectedList,
      inputOther: data.inputOther,
      year: schema.bugetYear,
      version: schema.version,
    }

    handleUpdateGoalTenYear(request)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.title}
        bordered
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isEdit && showCommandButton ? (
          <>
            {/* {formSchema.description && (
              <Row style={{ marginBottom: 10 }}>
                <CustomAlertMessage contents={formSchema.description} />
              </Row>
            )} */}

            <CheckboxRowHaveSubForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </>
        ) : (
          <CheckboxRowHaveSubView schema={formSchema} />
        )}

        {showCommandButton && !mode && (
          <div className="right">
            <hr />
            {notiMsg && (
              <Message
                closable
                showIcon
                type={notiMsg.type}
                description={notiMsg.msg}
                onClose={() => setNotiMsg('')}
                style={{ marginBottom: 10 }}
                className="left"
              />
            )}
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || formSchema.header}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </div>
        )}
      </Panel>
    </>
  )
}
